var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.classes.overlay }, [
    _c(
      "div",
      { class: _vm.classes.container },
      [
        _vm.tableOpen
          ? _c(
              "div",
              { class: _vm.classes.header },
              [
                _c("view-toggler", {
                  staticClass: "flex-hold",
                  attrs: { "is-table-open": _vm.tableOpen },
                  on: { toggled: _vm.toggleTable },
                }),
                _c("filter-bar", {
                  key: "filters",
                  attrs: { filters: _vm.filters, chains: _vm.chains },
                  on: { filtersChanged: _vm.$rbEmit },
                }),
                _c("local-search", {
                  class: _vm.$style.tableSearch,
                  attrs: { "search-term": _vm.query },
                  on: { onSearch: _vm.setQuery },
                }),
                _c("sorter", {
                  attrs: { sorter: _vm.sort, size: "large" },
                  on: { onDestinationSortChanged: _vm.setSortKey },
                }),
                _c("action-buttons", {
                  class: _vm.$style.actions,
                  on: {
                    save: _vm.save,
                    setDefaultFilters: _vm.setDefaultFilters,
                    done: _vm.done,
                  },
                }),
              ],
              1
            )
          : [
              _c(
                "div",
                { class: _vm.classes.header },
                [
                  _c("view-toggler", {
                    attrs: { "is-table-open": _vm.tableOpen },
                    on: { toggled: _vm.toggleTable },
                  }),
                  _c("properties-counter", {
                    class: _vm.$style.counter,
                    attrs: { count: _vm.suppliersCount },
                  }),
                ],
                1
              ),
              _c("div", { class: _vm.$style.searchFilterContainer }, [
                _c(
                  "div",
                  { class: _vm.$style.searchFilterHeader },
                  [
                    _c("filter-bar", {
                      key: "filters",
                      attrs: { filters: _vm.filters, chains: _vm.chains },
                      on: { filtersChanged: _vm.$rbEmit },
                    }),
                    _c("local-search", {
                      staticClass: "flex-100",
                      attrs: { "search-term": _vm.query },
                      on: { onSearch: _vm.setQuery },
                    }),
                    _c("sorter", {
                      staticClass: "flex-hold",
                      attrs: { size: "small", sorter: _vm.sort },
                      on: { onDestinationSortChanged: _vm.setSortKey },
                    }),
                  ],
                  1
                ),
              ]),
            ],
        _c(
          "v-list",
          {
            class: _vm.classes.items,
            attrs: {
              items: _vm.sortedSuppliers,
              size: 62,
              "scroll-to": _vm.scroll,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (item) {
                  return [
                    _vm.tableOpen
                      ? _c(
                          "div",
                          { class: _vm.$style.tableBody },
                          [
                            _c("expanded-supplier", {
                              class: _vm.$style.tableRowBody,
                              attrs: {
                                supplier: item.item,
                                filters: _vm.filters,
                                sorter: _vm.sort,
                              },
                              on: {
                                onRemoveFromBidManager: _vm.$rbEmit,
                                onAddToBidManager: _vm.$rbEmit,
                              },
                            }),
                          ],
                          1
                        )
                      : _c("shrinked-supplier", {
                          attrs: { supplier: item.item, sorter: _vm.sort },
                          on: {
                            onRemoveFromBidManager: _vm.$rbEmit,
                            onAddToBidManager: _vm.$rbEmit,
                            onSupplierMouseEnter: _vm.$rbEmit,
                            onSupplierMouseLeave: _vm.$rbEmit,
                            onPanMapTo: _vm.$rbEmit,
                          },
                        }),
                  ]
                },
              },
            ]),
          },
          [
            _vm.tableOpen
              ? _c("template", { slot: "before" }, [
                  _c("div", { class: _vm.$style.tableHead }, [
                    _c(
                      "div",
                      { class: _vm.$style.tableRowHead },
                      [
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn1",
                            class: _vm.$style.centered,
                            attrs: { id: "bidState", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [_vm._v(" ADD ")]
                        ),
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn3",
                            attrs: { id: "name", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [
                            _c("properties-counter", {
                              attrs: { count: _vm.suppliersCount },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn5",
                            attrs: { id: "city", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [_vm._v(" City ")]
                        ),
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn7",
                            attrs: { id: "state", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [_vm._v(" State/Region ")]
                        ),
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn9",
                            attrs: { id: "country", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [_vm._v(" Country ")]
                        ),
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn11",
                            attrs: { id: "distanceMi", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [_vm._v(" Distance ")]
                        ),
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn13",
                            attrs: { id: "chain", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [_vm._v(" Chain ")]
                        ),
                        _c(
                          "sortable",
                          {
                            staticClass: "msGridColumn15",
                            attrs: { id: "brand", by: _vm.sort },
                            on: { onDestinationSortChanged: _vm.setSortKey },
                          },
                          [_vm._v(" Brand ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
        !_vm.tableOpen
          ? _c(
              "div",
              { class: _vm.$style.tableFooter },
              [
                _c("action-buttons", {
                  class: _vm.$style.actions,
                  on: {
                    save: _vm.save,
                    setDefaultFilters: _vm.setDefaultFilters,
                    done: _vm.done,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }